import cx from 'classnames';
import humanDuration from 'core/libs/helpers/humanDuration';
import {withNextStepData} from 'modules/common/CourseNextStepButton';
import HeroBox from 'modules/common/HeroBox';
import MetaItem from 'modules/common/MetaItem';
import NewDesignButton from 'modules/common/NewDesignButton';
import Partnerships from 'modules/common/Partnerships';
import Clock from 'modules/common/Svg/Clock';
import InfoCircle from 'modules/common/Svg/InfoCircle';
import RightArrowAlt from 'modules/common/Svg/RightArrowAlt';
import WriteBoard from 'modules/common/Svg/WriteBoard';
import Tooltip from 'modules/common/Tooltip';
import VideoModal from 'modules/common/VideoModal';
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import {
  compose,
  setPropTypes,
  withHandlers,
  withProps,
  withState,
} from 'recompose';
import digitalOcean from 'theme/assets/images/digital-ocean-white.svg';

const TrackHeader = ({
  authenticated,
  backgroundImage,
  companiez,
  courses,
  description,
  duration,
  id,
  isDegree,
  join_count,
  level,
  name,
  percentage,
  toggleTrailerPopup,
  trackProgress,
  trailerPopup,
  trailerYoutubeId,
  durationInMonths,
  image,
  nextStep,
  remainingVideoTime,
  isBootcampEventsVisible,
  toggleBootcampEvents,
  subscription,
}) => {
  return (
    <HeroBox
      cyTitle="course-title"
      title={name}
      description={description}
      join_count={join_count}
      metas={
        <div>
          <div
            className={cx('flex items-center flex-row-ns flex-column', {
              'justify-center': isDegree,
            })}
          >
            {courses && courses.length > 0 && (
              <MetaItem cy="lessons">
                <WriteBoard color="#86e9b3" className="dib ml2 v-top" />
                {courses.length} <FormattedMessage id="courses" />
              </MetaItem>
            )}
            {(duration || durationInMonths) && (
              <MetaItem cy="duration">
                <Clock color="#86e9b3" className="dib ml2 v-top" />
                {isDegree ? ( // eslint-disable-line no-nested-ternary
                  <span>
                    {durationInMonths} <FormattedMessage id="months" />
                  </span>
                ) : remainingVideoTime ? (
                  <>
                    {trackProgress === 'started' && (
                      <>
                        <FormattedMessage id="remaining_time" />{' '}
                      </>
                    )}
                    {humanDuration(remainingVideoTime)}
                  </>
                ) : null}
              </MetaItem>
            )}
            {level && (
              <MetaItem cy="level" isLast={!companiez && id !== 1017}>
                {level}
              </MetaItem>
            )}
            {companiez && (
              <MetaItem
                cy="used-by"
                className="relative white"
                isLast={id !== 1017}
              >
                <FormattedMessage id="using_by" />
                <Tooltip
                  large
                  className="lh-copy"
                  message={
                    <div>
                      <p className="black">{companiez}</p>
                    </div>
                  }
                >
                  <InfoCircle className="dib v-top pointer grow" />
                </Tooltip>
              </MetaItem>
            )}
            {id === 1017 && (
              <MetaItem cy="partnership" isLast>
                <Partnerships
                  source={digitalOcean}
                  width="200"
                  height="40"
                  isTrackHeader
                />
              </MetaItem>
            )}
          </div>
        </div>
      }
      className={cx({
        'bg-black-90': isDegree,
        'bg-darker-primary-blue': !isDegree,
      })}
      background={
        isDegree ? image && image.url : backgroundImage && backgroundImage.url
      }
      video={!!trailerYoutubeId}
      onVideoClick={toggleTrailerPopup}
      isDegree={isDegree}
      isBootcampsPage
      isBootcampEventsVisible={isBootcampEventsVisible}
      toggleBootcampEvents={toggleBootcampEvents}
    >
      {/* {isDegree && activatedAt && (
        <div className="pv3 white tc">
          <FormattedMessage
            id="bootcamp_start_at"
            values={{
              day,
              month,
            }}
          />
        </div>
      )} */}
      <div
        className={cx('flex-ns items-center', {
          'justify-center': isDegree,
        })}
      >
        {!isDegree && (
          <NewDesignButton
            link="/tracks"
            className="link dim ba b--white pa3-ns ml3-ns mb2 mb0-ns"
            border={false}
          >
            <RightArrowAlt color="#fff" className="ml2" />
            <FormattedMessage id="return_tracks" />
          </NewDesignButton>
        )}
        <NewDesignButton
          className="db pv3 ph3 bg-green-light bg-animate hover-bg-green"
          link={subscription === 'ACTIVE' ? nextStep.url : nextStep.courseSlug}
          state = {{ fromLink: nextStep.url }}
        >
          <FormattedMessage
            id={
              // eslint-disable-next-line no-nested-ternary
              trackProgress === 'completed'
                ? isDegree
                  ? 'review_degree'
                  : 'review_track'
                : (trackProgress === 'started' &&
                    (isDegree ? 'continue_degree' : 'continue_track')) ||
                  (isDegree ? 'start_degree' : 'enroll_in')
            }
          />
        </NewDesignButton>
        <div className="ph2-ns pv0-ns pv1" />
        {!isDegree && authenticated && trackProgress !== 'completed' && (
          <span className="pv3 white db">
            <FormattedMessage id="progress_ratio" />{' '}
            <span className="ltr dib">{`${percentage}%`}</span>
          </span>
        )}
      </div>
      {isDegree && (
        <div className="tc">
          {authenticated && trackProgress !== 'completed' && (
            <span className="pv3 white db">
              <FormattedMessage id="progress_ratio" />{' '}
              <span className="ltr dib">{`${percentage}%`}</span>
            </span>
          )}
        </div>
      )}
      {trailerPopup && (
        <VideoModal
          rightButtonClick={toggleTrailerPopup}
          videoId={trailerYoutubeId}
          title={name}
        />
      )}
    </HeroBox>
  );
};

TrackHeader.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  backgroundImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  companiez: PropTypes.string,
  courses: PropTypes.arrayOf(PropTypes.object),
  description: PropTypes.string,
  duration: PropTypes.number,
  id: PropTypes.number.isRequired,
  isDegree: PropTypes.bool,
  join_count: PropTypes.number,
  level: PropTypes.string,
  name: PropTypes.string.isRequired,
  trackProgress: PropTypes.string,
  trailerYoutubeId: PropTypes.string,
  durationInMonths: PropTypes.number,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  nextStep: PropTypes.shape({
    url: PropTypes.string.isRequired,
    courseName: PropTypes.string,
    stageName: PropTypes.string,
    stepName: PropTypes.string,
  }).isRequired,
  remainingVideoTime: PropTypes.number.isRequired,
  percentage: PropTypes.number.isRequired,
  toggleTrailerPopup: PropTypes.func.isRequired,
  trailerPopup: PropTypes.bool.isRequired,
  isBootcampEventsVisible: PropTypes.bool,
  toggleBootcampEvents: PropTypes.func,
  activatedAt: PropTypes.string,
};

const enhance = compose(
  setPropTypes({
    stagesProgress: PropTypes.object.isRequired,
    stepsProgress: PropTypes.object.isRequired,
  }),
  withProps(({courses, stepsProgress}) => {
    let percentage = 0;
    let remainingVideoTime = 0;
    if (courses) {
      let totalStepsInTrack = 0;
      const totalStepsCompleted = courses.reduce((acc, course) => {
        let stepsCompletedForCourse = 0;
        if (course.stages)
          course.stages.forEach((stage) => {
            stage.steps.forEach((step) => {
              totalStepsInTrack += 1;
              if (
                stepsProgress[step.id] &&
                stepsProgress[step.id] === 'completed'
              ) {
                stepsCompletedForCourse += 1;
              } else if (step.videotutorial && step.duration) {
                remainingVideoTime += step.duration;
              }
            });
          });
        return acc + stepsCompletedForCourse;
      }, 0);
      if (totalStepsInTrack) {
        percentage = Math.round(
          (100 * totalStepsCompleted) / totalStepsInTrack,
        );
      }
    }
    return {
      percentage,
      remainingVideoTime,
    };
  }),
  withState('trailerPopup', 'setTrailerPopup', false),
  withHandlers({
    toggleTrailerPopup: ({setTrailerPopup, trailerPopup}) => () => {
      setTrailerPopup(!trailerPopup);
    },
  }),
  withNextStepData,
);

export default enhance(TrackHeader);
